module.exports = __webpack_public_path__ + "img/cil-book.c862835e.svg";